import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { kaminoApiRef, KaminoClient } from './api';

/**
 * The Kamino plugin for Backstage
 * @public
 */
export const kaminoPlugin = createPlugin({
  id: 'kamino',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: kaminoApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new KaminoClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/**
 * The main page for the Kamino plugin
 * @public
 */
export const KaminoPage = kaminoPlugin.provide(
  createRoutableExtension({
    name: 'KaminoPage',
    component: () => import('./components/Root').then(m => m.Root),
    mountPoint: rootRouteRef,
  }),
);
